import React from 'react';
import { motion } from 'framer-motion';
import styles from './HtsQuestionForm.module.scss';

interface SelectableOptionProps {
  selected: boolean;
  onClick: () => void;
  variant: 'card' | 'chip' | 'row';
  className?: string;
  children: React.ReactNode;
}

export const SelectableOption: React.FC<SelectableOptionProps> = ({
  selected,
  onClick,
  variant,
  className,
  children,
}) => {
  const variantClass = {
    card: styles.optCard,
    chip: styles.optChip,
    row: styles.optRow,
  }[variant];

  return (
    <motion.div
      role="radio"
      aria-checked={selected}
      tabIndex={0}
      className={[variantClass, selected ? styles.optSelected : '', className].filter(Boolean).join(' ')}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.98 }}
    >
      {children}
    </motion.div>
  );
};

export default SelectableOption;
